module.exports = __webpack_public_path__ + "static/isadora-6fa77942b580b4bf44f37c798736d164.mp3";